import React from "react";
import { ButtonHLPure, InstructionsPure, InputHLPure } from "../../pures";
import { PlusBlue } from "../../../assets/logos/icons";
import "./signature-base-validate.css";

const SignatureBaseValidate = (props) => {
    let {
        t,
        step,
        onHandleNext,
        onHandleBack,
        firstName,
        firstLastName,
        secondLastName,
        fullname,
        ineFrontImg,
        ineBackImg,
    } = props

    const { next, back } = step;

    return(
        <div className="signatureBaseValidate-container">
            <div className="signatureBaseValidate-body">
                <div className="signatureBaseValidate-text-container">
                    <div className="signatureBaseValidate-text">
                        <InstructionsPure instructions={[t("signatureBaseValidate.text")]}/>
                    </div>
                </div>
                <div className="signatureBaseValidate-container-items">
                    <div className="signatureBaseValidate-items">
                        <div className="signatureBaseValidate-container-inputs">
                            <InputHLPure
                                labelInput={t("profileAdministrationPrincipalView.name")}
                                valueInput={firstName}
                                typeInput={"text"}
                                inputActive={true}
                                disabled
                            />
                            <InputHLPure
                                labelInput={t("profileAdministrationPrincipalView.firstLastName")}
                                valueInput={firstLastName}
                                typeInput={"text"}
                                inputActive={true}
                                disabled
                            />
                            <InputHLPure
                                labelInput={t("profileAdministrationPrincipalView.secondLastName")}
                                valueInput={secondLastName}
                                typeInput={"text"}
                                inputActive={true}
                                disabled
                            />
                        </div>
                        <div className="signatureBaseValidate-container-images">
                            <div className="signatureBaseValidate-ine-front">
                                <div className={"rec-signature-base"}>
                                    <img className={"signatureBaseUploadINE-image-plus"} src={PlusBlue} width="40" />
                                    <img className={(ineFrontImg) ? "signatureBaseUploadINE-image-ine " :"signatureBaseUploadINE-image-default"} src={ineFrontImg} />
                                </div>
                            </div>
                            <div className="signatureBaseValidate-ine-back">
                                <div className={"rec-signature-base "} >
                                    <img className={"signatureBaseUploadINE-image-plus"} src={PlusBlue} width="40" />
                                    <img className={(ineBackImg) ? "signatureBaseUploadINE-image-ine" : "signatureBaseUploadINE-image-default"} src={ineBackImg} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="signatureBaseValidate-container-btns">
                <div className="signatureBaseValidate-btn-secundary">
                    <ButtonHLPure
                        nameBtn={back}
                        primary={false}
                        onClickBtn={onHandleBack}
                    />
                </div>
                <ButtonHLPure
                    nameBtn={next}
                    primary={true}
                    onClickBtn={onHandleNext}
                />
            </div>
        </div>
    )
}

export { SignatureBaseValidate as default }